import { AHIcon, AHText, Box, TouchableBox } from "arkh";

import React from "react";

export function AddPage({
  height,
  onAddPage,
  width,
}: {
  width: number;
  height: number;
  onAddPage: () => void;
}) {
  return (
    <Box
      key="ADD"
      style={{
        width,
        height,
        justifyContent: "center",
        alignItems: "center",
      }}
      color="surface"
      cornerRadius="medium"
    >
      <TouchableBox onPress={onAddPage} style={{ alignItems: "center" }}>
        <AHIcon type="add" size="xlarge" color="primary" />
        <AHText spaceTop="xsmall" type="body" color="primary">
          Lägg till sida
        </AHText>
      </TouchableBox>
    </Box>
  );
}
